import axios from "axios";
import authHeader from "./auth-header";
import VueCookies from "vue-cookies";
import { baseURL } from "../constants";

class DataService {
  getFaculties() {
    return axios.get(baseURL + "/faculties");
  }

  getProdi() {
    return axios.get(baseURL + "/prodi-tracer");
  }

  getProgramsChoise(id) {
    return axios.get(baseURL + `/program/${id}`);
  }

  getAlumniFilter(id) {
    return axios.get(baseURL + `/cari-alumni?id_prodi=${id}`);
  }

  getStudyPrograms() {
    return axios.get(baseURL + "/programs");
  }

  getStudyProgramsJenjang() {
    return axios.get(baseURL + "/prodi-jenjang");
  }

  getProvinsi() {
    return axios.get(baseURL + "/provinsi");
  }

  getWilayahChoise(id) {
    return axios.get(baseURL + `/wilayah/${id}`);
  }

  getAlumniChoise(id_tahun, tahun, id_prodi) {
    return axios.get(
      baseURL +
        `/list-alumni?id_tahun=${id_tahun}&tahun_lulusan=${tahun}&id_program_studi=${id_prodi}`,
      {
        headers: authHeader()
      }
    );
  }

  filterAlumniDynamic(filter) {
    return axios.get(baseURL + "/alumni/filter", {
      headers: authHeader(),
      params: filter || {}
    });
  }

  //umr
  getLevelWilayah() {
    return axios.get(baseURL + "/level-wilayah", {
      headers: authHeader()
    });
  }

  getLevelWilayahChoise(id) {
    return axios.get(baseURL + `/wilayah?id_level=${id}`, {
      headers: authHeader()
    });
  }

  getUmrWilayah() {
    return axios.get(baseURL + "/umr-wilayah", {
      headers: authHeader()
    });
  }

  createUmr(data) {
    return axios.post(baseURL + `/umr-wilayah`, data, {
      headers: authHeader()
    });
  }

  deleteUmr(id) {
    return axios.delete(baseURL + `/umr-wilayah/${id}`, {
      headers: authHeader()
    });
  }

  exportUmr() {
    return axios.get(baseURL + "/umr-wilayah/export", {
      headers: authHeader(),
      responseType: "blob"
    });
  }

  downloadUmrTemplate() {
    return axios.get(baseURL + "/umr-wilayah/template", {
      headers: authHeader(),
      responseType: "blob"
    });
  }

  importUmr(formData) {
    return axios.post(baseURL + "/umr-wilayah/import", formData, {
      headers: { ...authHeader(), "Content-Type": "multipart/form-data" }
    });
  }

  getSinkronUmr() {
    return axios.get(baseURL + "/sinkron-umr", {
      headers: authHeader()
    });
  }

  //prodi PDUT
  getSinkronProdi() {
    return axios.get(baseURL + "/sinkron-prodi", {
      headers: authHeader()
    });
  }

  getSinkronAlumni(id) {
    return axios.get(baseURL + `/sinkron-alumni?id_program_studi=${id}`, {
      headers: authHeader()
    });
  }

  // kaprodi
  getKaprodiAlumniChoise(id) {
    return axios.get(baseURL + `/list-alumni-prodi?kode_prodi=${id}`, {
      headers: authHeader()
    });
  }

  getTahunLulusanAlumni(id) {
    return axios.get(baseURL + `/list-tahun-lulusan-alumni`, {
      headers: authHeader()
    });
  }

  getTahunLulusan(id) {
    return axios.get(baseURL + `/list-tahun-lulusan-prodi?kode_prodi=${id}`, {
      headers: authHeader()
    });
  }

  getFilterAlumniChoise(id_tahun, tahun, data) {
    return axios.get(
      baseURL +
        `/filter-alumni-prodi?id_tahun=${id_tahun}&tahun_lulusan=${tahun}&kode_prodi=${data}`,
      {
        headers: authHeader()
      }
    );
  }

  getKaprodiSurveyors(id) {
    return axios.get(baseURL + `/surveyors-prodi?kode_prodi=${id}`, {
      headers: authHeader()
    });
  }

  getHasilTracerProdi(id) {
    return axios.get(baseURL + `/list-tracer-prodi?kode_prodi=${id}`, {
      headers: authHeader()
    });
  }

  getHasilTracerProdiChoise(id_tahun, tahun, data) {
    return axios.get(
      baseURL +
        `/filter-tracer-prodi?id_tahun=${id_tahun}&tahun_lulusan=${tahun}&kode_prodi=${data}`,
      {
        headers: authHeader()
      }
    );
  }

  //fakultas
  getTahunLulusanFakultas(id) {
    return axios.get(
      baseURL + `/list-tahun-lulusan-fakultas?kode_fakultas=${id}`,
      {
        headers: authHeader()
      }
    );
  }

  getAlumniChoiseFakultas(id) {
    return axios.get(baseURL + `/list-alumni-fakultas?kode_fakultas=${id}`, {
      headers: authHeader()
    });
  }

  getTahunLulusanFakultas(id) {
    return axios.get(
      baseURL + `/list-tahun-lulusan-fakultas?kode_fakultas=${id}`,
      {
        headers: authHeader()
      }
    );
  }

  getFilterAlumniChoiseFakultas(id_tahun, tahun, data) {
    return axios.get(
      baseURL +
        `/filter-alumni-fakultas?id_tahun=${id_tahun}&tahun_lulusan=${tahun}&kode_fakultas=${data}`,
      {
        headers: authHeader()
      }
    );
  }

  getSurveyorsFakultas(id) {
    return axios.get(baseURL + `/surveyors-fakultas?kode_fakultas=${id}`, {
      headers: authHeader()
    });
  }

  getHasilTracerFakultas(id) {
    return axios.get(baseURL + `/list-tracer-fakultas?kode_fakultas=${id}`, {
      headers: authHeader()
    });
  }

  getHasilTracerFakultasChoise(id_tahun, tahun, data) {
    return axios.get(
      baseURL +
        `/filter-tracer-fakultas?id_tahun=${id_tahun}&tahun_lulusan=${tahun}&kode_fakultas=${data}`,
      {
        headers: authHeader()
      }
    );
  }

  //alumni
  getAlumnis() {
    return axios.get(baseURL + "/alumni", {
      headers: authHeader()
    });
  }
  getAlumniStatus() {
    return axios.get(baseURL + "/alumni-status", {
      headers: authHeader()
    });
  }
  getAlumni(id) {
    return axios.get(baseURL + "/alumni/${id}", {
      headers: authHeader()
    });
  }
  createAlumni(data) {
    return axios.post(baseURL + "/alumni", data, {
      headers: authHeader()
    });
  }
  updateAlumni(id, data) {
    return axios.put(baseURL + "/alumni/${id}", data, {
      headers: authHeader()
    });
  }
  deleteAlumni(id) {
    return axios.delete(baseURL + "/alumni/${id}", {
      headers: authHeader()
    });
  }

  //surveyor
  getSurveyors() {
    return axios.get(baseURL + "/surveyors");
  }

  createSurveyor(data) {
    return axios.post(baseURL + `/surveyors`, data, {
      headers: authHeader()
    });
  }

  updateSurveyor(id, data) {
    return axios.put(baseURL + `/surveyor/${id}`, data, {
      headers: authHeader()
    });
  }

  deleteSurveyor(id) {
    return axios.delete(baseURL + `/surveyor/${id}`, {
      headers: authHeader()
    });
  }

  exportSurveyors() {
    return axios.get(baseURL + "/surveyors/export", {
      headers: authHeader(),
      responseType: "blob"
    });
  }

  //survey
  getTahunPeriode() {
    return axios.get(baseURL + "/tahun-periode", {
      headers: authHeader()
    });
  }

  getProdi() {
    return axios.get(baseURL + "/prodi-tracer", {
      headers: authHeader()
    });
  }

  getHasilTracer(filter) {
    var params = filter || {};
    return axios.get(baseURL + "/list-hasil-survey", {
      headers: authHeader(),
      params: params
    });
  }

  getHasilTracerChoise(id) {
    return axios.get(baseURL + `/hasil-survey?tahun=${id}`, {
      headers: authHeader()
    });
  }

  getProgramStudyTracer(id_tahun, tahun, id_prodi) {
    return axios.get(
      baseURL +
        `/hasil-survey-prodi?id_tahun=${id_tahun}&tahun=${tahun}&prodi=${id_prodi}`,
      {
        headers: authHeader()
      }
    );
  }

  getProgramStudyDudi(tahun, id_prodi) {
    return axios.get(
      baseURL + `/hasil-dudi-prodi?tahun=${tahun}&prodi=${id_prodi}`,
      {
        headers: authHeader()
      }
    );
  }

  getSinkronHasilTracer(id) {
    return axios.get(baseURL + `/sinkron-hasil-tracer?tahun=${id}`, {
      headers: authHeader()
    });
  }

  showEditor(id) {
    return axios.get(baseURL + `/survey-editor/${id}`, {
      headers: authHeader()
    });
  }

  //file
  downloadFileTracer(id_tahun, tahun, id_prodi) {
    return axios.get(
      baseURL +
        `/export-hasil-tracer?id_tahun=${id_tahun}&id_thn_ajaran=${tahun}&id_prodi=${id_prodi}`,
      {
        headers: authHeader(),
        responseType: "blob"
      }
    );
  }

  downloadFileTracerProdi(id_tahun, tahun, id_prodi) {
    return axios.get(
      baseURL +
        `/export-hasil-tracer-prodi?id_tahun=${id_tahun}&id_thn_ajaran=${tahun}&id_prodi=${id_prodi}`,
      {
        headers: authHeader(),
        responseType: "blob"
      }
    );
  }

  downloadFileTracerFakultas(id_tahun, tahun, kode_fakultas) {
    return axios.get(
      baseURL +
        `/export-hasil-tracer-fakultas?id_tahun=${id_tahun}&id_thn_ajaran=${tahun}&kode_fakultas=${kode_fakultas}`,
      {
        headers: authHeader(),
        responseType: "blob"
      }
    );
  }

  downloadFileAlumni(id_tahun, tahun, id_prodi) {
    return axios.get(
      baseURL +
        `/export-data-alumni?id_tahun=${id_tahun}&id_thn_ajaran=${tahun}&id_prodi=${id_prodi}`,
      {
        headers: authHeader(),
        responseType: "blob"
      }
    );
  }

  downloadFileProdi() {
    return axios.get(baseURL + `/export-data-prodi`, {
      headers: authHeader(),
      responseType: "blob"
    });
  }

  downloadFileAlumniKaprodi(id_tahun, tahun, id_prodi) {
    return axios.get(
      baseURL +
        `/export-data-alumni-kaprodi?id_tahun=${id_tahun}&id_thn_ajaran=${tahun}&kode_prodi=${id_prodi}`,
      {
        headers: authHeader(),
        responseType: "blob"
      }
    );
  }

  downloadFileAlumniFakultas(id_tahun, tahun, kode_fakultas) {
    return axios.get(
      baseURL +
        `/export-data-alumni-fakultas?id_tahun=${id_tahun}&id_thn_ajaran=${tahun}&kode_fakultas=${kode_fakultas}`,
      {
        headers: authHeader(),
        responseType: "blob"
      }
    );
  }

  //users
  getUsers() {
    return axios.get(baseURL + "/users", {
      headers: authHeader()
    });
  }

  //roles
  getRoles() {
    return axios.get(baseURL + "/roles", {
      headers: authHeader()
    });
  }

  //dudi
  getHasilDudi(kode_prodi, tahun) {
    return axios.get(
      baseURL + `/hasil-dudi?kode_prodi=${kode_prodi}&id_thn_ajaran=${tahun}`,
      {
        headers: authHeader()
      }
    );
  }

  getHasilDudiChoise(kode_prodi, tahun) {
    return axios.get(
      baseURL +
        `/hasil-dudi-tahun?kode_prodi=${kode_prodi}&id_thn_ajaran=${tahun}`,
      {
        headers: authHeader()
      }
    );
  }

  downloadFileDudi(tahun, id_prodi) {
    return axios.get(
      baseURL + `/export-dudi?id_thn_ajaran=${tahun}&id_prodi=${id_prodi}`,
      {
        headers: authHeader(),
        responseType: "blob"
      }
    );
  }

  downloadFileDudiProdi(tahun, id_prodi) {
    return axios.get(
      baseURL +
        `/export-dudi-prodi?id_thn_ajaran=${tahun}&kode_prodi=${id_prodi}`,
      {
        headers: authHeader(),
        responseType: "blob"
      }
    );
  }

  downloadFileDudiFakultas(tahun, kode_fakultas) {
    return axios.get(
      baseURL +
        `/export-dudi-fakultas?id_thn_ajaran=${tahun}&kode_fakultas=${kode_fakultas}`,
      {
        headers: authHeader(),
        responseType: "blob"
      }
    );
  }
  exportTracerStudy(data) {
    return axios.post(baseURL + `/export-tracer-study`, data, {
      headers: authHeader(),
      responseType: "blob"
    });
  }
}

export default new DataService();
